import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { bootstrapAuth, fetchMyProfile } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';
import { useCompanyStore } from '../../store/companyStore';
import { needsDisplayNameSetup } from '../../utils/displayName';

function ProtectedRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const location = useLocation();

  useEffect(() => {
    if (!isHydrated) {
      void bootstrapAuth();
    }
  }, [isHydrated]);

  if (!isHydrated) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#667085' }}>
        로그인 상태 확인 중...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

/** 표시 이름이 없으면 회사 선택/앱 진입 전에 설정 화면으로 보냄 */
function DisplayNameRequiredRoute() {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const profile = await fetchMyProfile();
        if (!cancelled) {
          setNeedsSetup(needsDisplayNameSetup(profile.nickname));
        }
      } catch {
        if (!cancelled) setNeedsSetup(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    void check();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (checking) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#667085' }}>
        프로필 확인 중...
      </div>
    );
  }

  if (needsSetup) {
    return <Navigate to="/setup-profile" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

function CompanyRequiredRoute() {
  const hasCompany = useCompanyStore((state) => state.hasCompany);
  const location = useLocation();

  if (!hasCompany) {
    return <Navigate to="/companies" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export { CompanyRequiredRoute, DisplayNameRequiredRoute };
export default ProtectedRoute;
